// extracted by css-extract-rspack-plugin
export default {"viewName":"kghPSO6ps8z_Ym7h"};